import React from 'react';

import positiony from '../Support/Positiony';

const positionTable = (props) => {

	let last_row_name = '';
	let row_counter = 1;

	let results = Object.keys(props.results)
		.map(row => {

			const r = props.results[row];

			const cd = r.court_decision ? positiony(r.court_decision) : '';
			const ms = r.mediated_settlement ? positiony(r.mediated_settlement) : '';

			let row_classes = '';
			if(+props.activePosition === +row) row_classes = 'active';

			let row_name = r.name;

			if(last_row_name !== row_name) {
				last_row_name = row_name;
				row_counter = 1;
			}
			else {
				row_counter += 1;
			}

			if(row_name.indexOf(' Case') >= 0) {
				let row_name_count = '';
				if(row_counter > 1) row_name_count = ' ' + row_counter;
				row_name = [r.name.replace(' Case',''), <span key={row} className='shorthand'> Case</span>, row_name_count];
			}

			let row_desc = r.description;
			if(row_desc.indexOf('- Mediation') >= 0)
				row_desc = [r.description.replace('- Mediation', ''), <span key={row} className='shorthand'>- Mediation</span>, <span key={row + 1} className='iconic screen-only'><i className='fas fa-comment'></i></span>];
			if(row_desc.indexOf('at Trial') >= 0)
				row_desc = [r.description.replace('at Trial', ''), <span key={row} className='shorthand'>at Trial</span>, <span key={row + 1} className='iconic screen-only'><i className='fas fa-gavel'></i></span>];

			return (
				<tr key={row} className={row_classes} onClick={() => props.selector(row)}>
					<td className='number'>{+row + 1}</td>
					<td className='wide'><h6>{row_name}</h6><p>{row_desc}</p></td>
					<td>{cd}</td>
					<td>{ms}</td>
					<td>{positiony(r.legal_costs)}</td>
					<td>{positiony(r.net_settlement)}</td>
				</tr>
			);

		});

	let classes = 'positions positions--' + props.colour;


	return (
		<div className={'position-table position-table--' + props.ident}>
			<h4 className='position-table__name'>{props.name}</h4>
			<table className={classes}>
				<thead>
					<tr>
						<th className='positions__number'>&nbsp;</th>
						<th className='positions__category wide'><span className='positions__result--text-full'>Category</span><span className='positions__result--text-small'>Case</span></th>
						<th className='positions__result'><span className='positions__result--text-full'>Court Decision</span><span className='positions__result--text-small'>CD</span></th>
						<th className='positions__result'><span className='positions__result--text-full'>Mediated Settlement</span><span className='positions__result--text-small'>MS</span></th>
						<th className='positions__result'><span className='positions__result--text-full'>Legal Costs</span><span className='positions__result--text-small'>LC</span></th>
						<th className='positions__result'><span className='positions__result--text-full'>Net Settlement</span><span className='positions__result--text-small'>NS</span></th>
					</tr>
				</thead>
				<tbody>
					{results}
				</tbody>
			</table>
		</div>
	);
}

export default positionTable;


// WEBPACK FOOTER //
// ./src/Blocks/PositionTable.js